var map = {
	"./src/proj1/data.json": 2771,
	"./src/proj10/data.json": 6130,
	"./src/proj11/data.json": 4674,
	"./src/proj12/data.json": 7400,
	"./src/proj13/data.json": 8446,
	"./src/proj14/data.json": 9983,
	"./src/proj15/data.json": 5678,
	"./src/proj16/data.json": 7532,
	"./src/proj17/data.json": 4030,
	"./src/proj18/data.json": 2808,
	"./src/proj2/data.json": 8455,
	"./src/proj3/data.json": 6354,
	"./src/proj4/data.json": 8480,
	"./src/proj5/data.json": 3631,
	"./src/proj6/data.json": 6512,
	"./src/proj7/data.json": 5477,
	"./src/proj8/data.json": 5050,
	"./src/proj9/data.json": 3603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8380;